import isMobile from "ismobilejs";

export const getCurrentDevice = (): "phone" | "tablet" | "desktop" => {
  const deviceNavigatorObj = isMobile(window.navigator);

  return deviceNavigatorObj?.phone ? "phone" : deviceNavigatorObj?.tablet ? "tablet" : "desktop";
};
